<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" md="8">
          <v-select
            v-model="selectedMemberAccountColumn"
            :items="MemberAccountColumn"
            label="匯出欄位"
            multiple
            :rules="selectRequiredRules"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle" >
                <v-list-item-action>
                  <v-icon :color="selectedMemberAccountColumn.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>全部</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:append-item>
              <v-divider class="mb-2"></v-divider>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" md="8">
          <div style="float:right;">
            <v-btn color="red" style="color:white;" :disabled="(!valid)  " @click.prevent="downloadReport();">EXCEL下載</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import { mapGetters, mapActions } from "vuex";
import { Checkbox } from "element-ui";

export default {
  components: {
     [Checkbox.name]: Checkbox
    // InterpreterDetail
  },
  computed: {
    ...mapActions([
      "updateSearchCase"
    ]),
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"]
    }),
   
    likesAllFruit () {
      return this.selectedMemberAccountColumn.length === this.MemberAccountColumn.length
    },
    likesSomeFruit () {
      return this.selectedMemberAccountColumn.length > 0 && !this.likesAllFruit
    },
    icon () {
      if (this.likesAllFruit) return 'mdi-close-box'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  data() {
    return {
      valid: false,
      selectedMemberAccountColumn: [],
      requiredRules: [v => !!v || "此欄位是必填"],
      selectRequiredRules: [v => v.length != 0 || "此欄位是必填"],
      MemberAccountColumn: [
        "姓名",
        "性別", 
        "統一證號或身分證字號", 
        "出生日期", 
        "原屬國籍", 
        "教育程度", 
        "現職", 
        "在臺資格與取得證件", 
        "聯絡地址",
        "住家電話", 
        "行動電話", 
        "電子信箱", 
        "個人註記及通譯服務經歷", 
        "開始從事通譯服務時間", 
        "服務類型", 
        "熟悉語言", 
        "可服務地點", 
        "可服務時間"
      ],
    };
  },
  watch: {
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    
    downloadReport() {
        var vm = this;
        window.open(
            vm.idbServerUrl + "idb/InterpreterExportServlet?" + "column="+this.selectedMemberAccountColumn
        );
    },

    toggle () {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedMemberAccountColumn = []
        } else {
          this.selectedMemberAccountColumn = this.MemberAccountColumn.slice()
        }
      })
    },
  
  },
  mounted() {
  }
};
</script>




